import { Button, Group, Modal } from "@mantine/core";
import { Dispatch, SetStateAction } from "react";

interface DialogProps {
  title: string;
  open: boolean;
  children: React.ReactNode;
  onCancel?: Dispatch<SetStateAction<any>>;
  cancelLabel?: string;
  onConfirm?: Dispatch<SetStateAction<any>>;
  confirmLabel?: string;
}

export default function Dialog({
  title,
  open,
  children,
  onCancel,
  cancelLabel,
  onConfirm,
  confirmLabel,
}: DialogProps) {
  return (
    <Modal
      opened={open}
      onClose={() => onCancel?.(false)}
      title={title}
      lockScroll={false}
      centered
    >
      <Modal.Body>{children}</Modal.Body>

      <Group justify="flex-end" mt="md">
        {cancelLabel && (
          <Button variant="outline" onClick={() => onCancel?.(false)}>
            {cancelLabel}
          </Button>
        )}

        {confirmLabel && (
          <Button variant="filled" onClick={() => onConfirm?.(false)}>
            {confirmLabel}
          </Button>
        )}
      </Group>
    </Modal>
  );
}
